import * as tslib_1 from "tslib";
import { AbstractPageComponent } from 'src/app/shared/components/abstract-page/abstract-page.component';
var NewsOverviewPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NewsOverviewPageComponent, _super);
    function NewsOverviewPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultTitle = 'News overview';
        return _this;
    }
    return NewsOverviewPageComponent;
}(AbstractPageComponent));
export { NewsOverviewPageComponent };
